import { MdOutlineArrowRightAlt } from 'react-icons/md';
import { MultiSuggestLegItem } from '@lp/features/MultiSuggest';
import { formatTimestamp, msToFixedHours } from '@/utils/helpers';
import { LocationItem } from './LocationItem';

type RouteLegProps = {
  leg: MultiSuggestLegItem;
};

export const RouteLeg = ({ leg }: RouteLegProps) => {
  const startTime = formatTimestamp(leg.departureTime, leg.departureLocalTimezone, 'HH:mm');
  const endTime = formatTimestamp(leg.arrivalTime, leg.arrivalLocalTimezone, 'HH:mm');
  const timeDuration = msToFixedHours(leg.timeDurationInMs);

  return (
    <div className="flex gap-2 items-center">
      <div className="flex gap-1 items-center">
        <LocationItem locationId={leg.departureLocationId} />
        <MdOutlineArrowRightAlt size={16} />
        <LocationItem locationId={leg.arrivalLocationId} />
      </div>
      <span className="text-s-r text-base-10">{`${startTime} - ${endTime}`}</span>
      <span className="ml-auto text-s-r text-base-10">{timeDuration}</span>
    </div>
  );
};
